import { composeIO } from 'react-compose-io'
import { detalhesCicloPedidoIO } from './DetalhesCicloPedido.IO'
import { DetalhesCicloPedidoView } from './DetalhesCicloPedido.View'

export const DetalhesCicloPedido = composeIO(DetalhesCicloPedidoView, detalhesCicloPedidoIO)
